import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { object, shape, bool, func, string } from 'prop-types'
import Transition from 'react-transition-group/Transition'
import queryString from 'query-string'
import { debounce } from 'lodash'

import './MobileMenu.scss'

import logo from '../AppHeader/assets/logo.svg'
import PopUp from '../../common/Modals/PopUp'
import SectionPopUp from '../../common/Modals/SectionPopUp'
import searchIconGreen from './assets/search-mobile.svg'
import searchIcon from '../AppHeader/assets/search-icon.svg'
import Post from './assets/post.svg'
import Plus from './assets/plus.svg'
// import imageUser from '../AppHeader/assets/user.jpg'
import Close from '../../routes/Home/assets/close.svg'
import { openModal, mobileNavigate, getSearchType } from '../../modules/Main'
import { togglePasarminaScroll } from '../../modules/Home'
import { doLogout } from '../../modules/User'
import sortByProperty from '../../utils/sort'

class MobileMenu extends Component {
  static contextTypes = {
    router: object,
  }

  state = {
    showMagnifier: false,
    search: '',
    showHoverSearch: false,
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  onLogout = () => {
    this.props.openModal(false)
    this.props.doLogout()
  }

  handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    const status = scrollTop && scrollTop > 150
    this.setState({
      showMagnifier: status,
    })
  }

  handleMenuOnclick = route => () => {
    this.props.openModal(false)

    if (route === '/pasarmina') {
      this.props.togglePasarminaScroll(true)
    } else {
      this.props.mobileNavigate(route)
    }
  }

  handleOnFieldFocus = (e) => {
    this.props.getSearchType(e.target.value)
    this.setState({
      showHoverSearch: true,
    })
  }

  handleOnFieldChange = (e) => {
    this.setState({
      search: e.target.value,
    })
    this.debounced(e.target.value)
  }

  handleOnFieldBlur = () => {
    setTimeout(() => {
      this.setState({
        showHoverSearch: false,
      })
    }, 500)
  }

  handleSearch = () => {
    const { router: { history } } = this.context
    const { search } = this.state
    history.push({ pathname: '/search', search: queryString.stringify({ q: search }) })
  }

  handleKeyPressSearch = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch()
      this.inputSearch.blur()
    }
  }

  debounced = debounce((content) => {
    this.props.getSearchType(content)
  }, 500)

  showSearchBox = () => {
    this.setState({
      showMagnifier: false,
    })
  }

  render() {
    const { modalIsOpen, isLoggedIn, user, searchType } = this.props
    const { showMagnifier, search, showHoverSearch } = this.state
    const defaultStyle = {
      transition: 'transform 300ms ease-in-out',
      transform: 'translateX(-100%)',
    }

    const transitionStyles = {
      entering: { transform: 'translateX(-100%)' },
      entered: { transform: 'translateX(0)' },
    }
    return (
      <div className='mobile__header__wrapper visible-s visible-xs'>
        <div className='mobile__header'>
          <div className='container'>
            <div className='row'>
              <div className='rl-cl-s-12 clearfix'>
                <a className='hamburger clearfix' onClick={() => this.props.openModal(true)}>
                  <span className='hamburger__shape' />
                  <span className='hamburger__shape' />
                  <span className='hamburger__shape' />
                </a>
                <Link to='/' className='logo__mobile'>
                  <img src={logo} alt='Logo Minapoli' />
                </Link>
                {
                  showMagnifier ?
                    <div className='mobile__minifier' onClick={() => this.showSearchBox()}>
                      <img src={searchIconGreen} className='img__full' alt='' />
                    </div> : null
                }
              </div>
            </div>
          </div>
          <Transition in={modalIsOpen} timeout={0}>
            {state => (
              <div
                className='mobile__drawer' style={{
                  ...defaultStyle,
                  ...transitionStyles[state] }}>
                <div className='mobile__drawer__overlay' />
                <div className='mobile__drawer__content'>
                  <ul className='list-unstyled mobile__drawer__content__top'>
                    {/* <li className='menu--green'>
                      <a onClick={this.handleMenuOnclick('/user/add/pasarmina')} className='menu__link'>
                        <img className='icon' src={Plus} alt='pasang info menu' />
                        Pasang Iklan
                      </a>
                    </li>
                    <li className='menu--green'>
                      <a onClick={this.handleMenuOnclick('/user/add/infomina')} className='menu__link'>
                        <img className='icon' src={Post} alt='pasang iklan menu' />
                        Buat Post
                      </a>
                    </li> */}
                    <li><div className='divider' /></li>
                    <li>
                      <a onClick={this.handleMenuOnclick('/pasarmina')} className='menu__link'>
                        <span>pasar</span>mina
                      </a>
                    </li>
                    <li>
                      <a onClick={this.handleMenuOnclick('/event')} className='menu__link'>
                        <span>event</span>mina
                      </a>
                    </li>
                    <li>
                      <a onClick={this.handleMenuOnclick('/info')} className='menu__link'>
                        <span>info</span>mina
                      </a>
                    </li>
                    <li><div className='divider' /></li>
                    {isLoggedIn && <li>
                      <a
                        className='menu__link'
                        onClick={this.handleMenuOnclick('/user/profile')}>
                        Profil Saya
                      </a>
                    </li>}
                    <li>
                      <a onClick={this.handleMenuOnclick('/about')} className='menu__link'>Tentang Kami</a>
                    </li>
                    <li>
                      <SectionPopUp section='contactus'>
                        <a className='menu__link'>Hubungi Kami</a>
                      </SectionPopUp>
                    </li>
                    {isLoggedIn && <li>
                      <a onClick={this.onLogout} className='menu__link'>
                        Keluar
                      </a>
                    </li>}
                  </ul>
                </div>
                <div className='mobile__drawer__header'>
                  <a className='mobile__drawer__close' onClick={() => this.props.openModal(false)}>
                    <img className='img__full' src={Close} alt='' />
                  </a>
                  {/* isLoggedIn ? (
                    <div>
                      <Link className='user__icon__header' to='/'>Hi, {user.name.substring(0, 10)}
                        <div className='user__image'>
                          <img className='rounded__image' src={user.profile_pic} alt='' />
                        </div>
                      </Link>
                    </div>
                  ) :
                    <div className='user__icon__header'>
                      <PopUp buttonTitle={(<a style={{ color: '#00C6C9' }}>Masuk/Login</a>)} customClass='special' />
                    </div>
                  */}
                </div>
              </div>
            )}
          </Transition>
        </div>
        <div className={`mobile__magnifier clearfix ${showMagnifier ? 'hides' : ''}`}>
          <div className='search__box is__mobile'>
            <div className='container'>
              <div className='row'>
                <div className='rl-cl-s-12'>
                  <div className='search__wrap'>
                    <div className='search__left'>
                      <input
                        ref={(ref) => { this.inputSearch = ref }}
                        onKeyPress={this.handleKeyPressSearch}
                        onFocus={this.handleOnFieldFocus}
                        onChange={this.handleOnFieldChange}
                        onBlur={this.handleOnFieldBlur}
                        value={search || ''}
                        type='text'
                        id='search__input'
                        placeholder='Cari Produk / Info'
                        className='search__input' />
                      <ul
                        className={`search__result ${showHoverSearch ? 'animate' : ''}`}
                        onMouseEnter={this.mouseSearchResultEnter}
                        onMouseLeave={this.mouseSearchResultLeave}>
                        <li>
                          <span>Pasarmina</span>
                        </li>
                        {searchType &&
                          searchType.pasar &&
                          sortByProperty(searchType.pasar, 'name').map((item, index) => (
                            <li key={[`pasar-search-${index}`]}>
                              <Link to={`/p/${item.slug}`}>{item.name}</Link>
                            </li>
                          ))}
                        <li>
                          <div className='divider' />
                        </li>
                        <li>
                          <span>Eventmina</span>
                        </li>
                        {searchType &&
                          searchType.event &&
                          sortByProperty(searchType.event, 'name').map((item, index) => (
                            <li key={[`event-search-${index}`]}>
                              <Link to={`/e/${item.slug}`}>{item.name}</Link>
                            </li>
                          ))}
                        <li>
                          <div className='divider' />
                        </li>
                        <li>
                          <span>Infomina</span>
                        </li>
                        {searchType &&
                          searchType.info &&
                          sortByProperty(searchType.info, 'name').map((item, index) => (
                            <li key={[`info-search-${index}`]}>
                              <Link to={`/i/${item.slug}`}>{item.name}</Link>
                            </li>
                          ))}
                      </ul>
                    </div>
                    <div className='search__right'>
                      <button type='button'><img src={searchIcon} alt='search icon' /></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

MobileMenu.defaultProps = {
  modalIsOpen: false,
  isLoggedIn: false,
  user: { name: '' },
  searchType: {},
}

MobileMenu.propTypes = {
  modalIsOpen: bool,
  isLoggedIn: bool,
  user: shape({
    name: string,
  }),
  openModal: func.isRequired,
  togglePasarminaScroll: func.isRequired,
  mobileNavigate: func.isRequired,
  doLogout: func.isRequired,
  getSearchType: func.isRequired,
  searchType: object,
}

const mapStateToProps = ({ main, user }) => ({
  modalIsOpen: main.modalIsOpen,
  isLoggedIn: user.isLoggedIn,
  user: user.data,
  searchTypeRequest: main.searchTypeRequest,
  searchTypeError: main.searchTypeError,
  searchType: main.searchType,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  openModal,
  togglePasarminaScroll,
  mobileNavigate,
  doLogout,
  getSearchType,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MobileMenu)



// WEBPACK FOOTER //
// ./src/common/Menu/MobileMenu.js